<template>
<div>
  <v-row>
    <v-col cols="12" sm="2">
      <MyButtons />
    </v-col>
    <v-col cols="12" sm="3">
      <p class="mytitle primary--text">گزارش عملکرد {{formTitle}}</p>
    </v-col>
  </v-row>
  <v-row v-if="this.route === 'bank_accounts'">
    <v-col cols="12" sm="3">
      <MyBankaccounts :refs="true" v-model="bank_account_id" @change="debounceSearch()" />
    </v-col>
    <v-col cols="12" sm="3">
      <MyReportRange v-model="range" @change="debounceSearch()" />
    </v-col>
    <v-col cols="3" sm="2" v-if="range === 'dateRange'">
      <!-- <MyDate label="از تاریخ" v-model="date.from" @blur="retrieveData()" @setValue="setFromDateValue($event)" /> -->
      <MyDate label="از تاریخ" v-model="date.from" @input="debounceSearch" @setValue="setFromDateValue($event)" />
    </v-col>
    <v-col cols="3" sm="2" v-if="range === 'dateRange'">
      <!-- <MyDate label="تا تاریخ" v-model="date.to" @blur="retrieveData()" @setValue="setToDateValue($event)" /> -->
      <MyDate label="تا تاریخ" v-model="date.to" @input="debounceSearch" @setValue="setToDateValue($event)" />
    </v-col>
  </v-row>
  <v-row v-if="['products'].includes(this.route)">
    <v-col cols="12" sm="3">
      <MyProducts :refs="true" v-model="product_id" @change="debounceSearch()" />
    </v-col>
  </v-row>
  <v-row v-if="['invoices'].includes(this.route)">
    <v-col cols="12" sm="3">
      <MyProducts :refs="true" v-model="product_id" @change="debounceSearch()" />
    </v-col>
    <v-col cols="12" md="2">
      <v-radio-group v-model="invoice_type" row required @change="debounceSearch()">
        <v-radio label="فروش" value="sale"></v-radio>
        <v-radio label="خرید" value="buy"></v-radio>
      </v-radio-group>
    </v-col>
    <v-col cols="12" sm="3">
      <MyPersons v-model="person_id" @change="debounceSearch()" />
    </v-col>
  </v-row>
  <div v-if="loading">
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
  <div v-else>
    <v-row v-if="route === 'products'">
      <v-col cols="12" sm="7">
        <MyListTable :headers="headers" :data="data" />
      </v-col>
      <v-col cols="12" sm="5">
        <MyListTable :headers="cols" :data="rows" />
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12" sm="12">
        <MyListTable :headers="headers" :data="data" />
      </v-col>
    </v-row>
  </div>
</div>
</template>

<script>
import myAxios from '../../../functions/myAxios'
import MyListTable from '../../list/Table.vue'
import MyButtons from '../Buttons.vue'
import MyProducts from '../../../components/MyProducts.vue'
import MyBankaccounts from '../../../components/MyBankaccounts.vue'
import MyPersons from '../../../components/MyPersons.vue'
import MyReportRange from './MyReportRange.vue'
import MyDate from '../../../components/MyDate.vue'
import {
  toJalaali,
} from '../../../functions/myDate'
import headers from './setting.json'
export default {
  name: 'reportS',
  methods: {
    getRequestParams(product_id, bank_account_id, invoice_type, person_id, range, date) {
      let params = {}

      if (range) {
        params["range"] = range
      }

      if (range === "dateRange" && date) {
        params["date"] = date
      }

      if (product_id) {
        params["mid"] = product_id
        delete params["range"]
      }

      if (bank_account_id) {
        params["mid"] = bank_account_id
      }

      if (person_id) {
        params["person_id"] = person_id
      }

      if (invoice_type) {
        params["invoice_type"] = invoice_type
      }

      return params
    },
    async retrieveData() {
      if (this.route === 'products' && !this.product_id) return;
      if (this.route === 'bank_accounts' && !this.bank_account_id) return;
      if (this.route === 'invoices' && !this.product_id) return;
      const query = this.getRequestParams(
        this.product_id,
        this.bank_account_id,
        this.invoice_type,
        this.person_id,
        this.range,
        this.date,
      )
      try {
        this.loading = true
        let _url = this.route
        if (this.route === 'invoices') {
          _url += `/${this.invoice_type}`
        }
        let res = await myAxios({
          method: 'GET',
          url: `/api/${_url}/report`,
          params: query
        });
        // console.log(res.data);
        if (res && res.data) {
          if (this.route === 'products') {
            this.data = res.data.report
            this.rows = res.data.existingBuys.reverse()
          } else {
            this.data = res.data
          }
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false
      }
    },
    debounceSearch() {
      clearTimeout(this.debounce)
      //
      this.debounce = setTimeout(() => {
        this.retrieveData()
      }, 1000)
    },
    setFromDateValue(item) {
      this.date.from = item
      this.date.to = item
      this.debounceSearch()
    },
    setToDateValue(item) {
      this.date.to = item
      this.debounceSearch()
    },
  },
  data: () => ({
    person_id: null,
    product_id: null,
    bank_account_id: null,
    invoice_type: 'sale',
    range: 'today',
    date: {
      from: null,
      to: null,
    },
    loading: false,
    data: [],
    headers: [],
    rows: [],
    cols: []
  }),
  created() {
    this.route = this.$store.getters.pageInfo.route
    this.formTitle = this.$store.getters.pageInfo.formTitle
    this.headers = headers[this.route]
    this.cols = headers['buys']
  },
  mounted() {
    this.date.from = toJalaali(new Date()).date
    this.date.to = toJalaali(new Date()).date
  },
  components: {
    MyListTable,
    MyButtons,
    MyProducts,
    MyBankaccounts,
    MyPersons,
    MyReportRange,
    MyDate,
  }
}
</script>
